export class PasswordChange { 
    OldPassword: string;
    NewPassword: string;

    constructor(){
        this.OldPassword = "";
        this.NewPassword = "";
    }
}